// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screener-criteria-detail-list {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1px;
}

.screener-criteria-detail-list-empty {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Arial', 'Helvetica', 'Sans-serif';
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #1E1F2F;
}`, "",{"version":3,"sources":["webpack://./src/Components/Screener/Criteria/CriteriaDetailList/CriteriaDetailList.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB","sourcesContent":[".screener-criteria-detail-list {\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1px;\n}\n\n.screener-criteria-detail-list-empty {\n    box-sizing: border-box;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-family: 'Arial', 'Helvetica', 'Sans-serif';\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    color: #1E1F2F;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
